export default __webpack_public_path__ + "static/media/be75652db97f6007e736029d7d5707e0.bc5a0795.svg";